"use strict";
// https://ballysports.atlassian.net/wiki/spaces/EN/pages/64061467/Labels
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decorateLabel = exports.isTextLabel = exports.isTimeRangeLabel = exports.isTimeLabel = exports.isDateTimeLabel = exports.isShortDateLabel = exports.isDurationLabel = exports.Label = exports.TextLabel = exports.TimeRangeLabel = exports.TimeLabel = exports.DateTimeLabel = exports.ShortDateLabel = exports.DurationLabel = void 0;
var zod_1 = require("zod");
var date_1 = require("../../utility/date");
exports.DurationLabel = zod_1.z.object({
    type: zod_1.z.literal('duration'),
    value: zod_1.z.number().describe('Duration in milliseconds')
});
exports.ShortDateLabel = zod_1.z.object({
    type: zod_1.z.literal('short_date'),
    value: date_1.ISO8601.describe('Short date')
});
exports.DateTimeLabel = zod_1.z.object({
    type: zod_1.z.literal('datetime'),
    value: date_1.ISO8601.describe('Date and time')
});
exports.TimeLabel = zod_1.z.object({
    type: zod_1.z.literal('time'),
    value: date_1.ISO8601.describe('Time')
});
exports.TimeRangeLabel = zod_1.z.object({
    type: zod_1.z.literal('datetime_range'),
    start: date_1.ISO8601,
    end: date_1.ISO8601
});
exports.TextLabel = zod_1.z.object({
    type: zod_1.z.literal('text'),
    value: zod_1.z.string().describe('Text'),
    markdown: zod_1.z.string().optional()
});
exports.Label = zod_1.z
    .discriminatedUnion('type', [
    exports.DurationLabel,
    exports.ShortDateLabel,
    exports.DateTimeLabel,
    exports.TimeLabel,
    exports.TimeRangeLabel,
    exports.TextLabel
])
    .and(zod_1.z.object({
    is_live: zod_1.z.boolean().optional().describe('Whether or not to show the live indicator')
}));
// Helper utilities for checking label types
var isDurationLabel = function (label) { return label.type === 'duration'; };
exports.isDurationLabel = isDurationLabel;
var isShortDateLabel = function (label) {
    return label.type === 'short_date';
};
exports.isShortDateLabel = isShortDateLabel;
var isDateTimeLabel = function (label) { return label.type === 'datetime'; };
exports.isDateTimeLabel = isDateTimeLabel;
var isTimeLabel = function (label) { return label.type === 'time'; };
exports.isTimeLabel = isTimeLabel;
var isTimeRangeLabel = function (label) {
    return label.type === 'datetime_range';
};
exports.isTimeRangeLabel = isTimeRangeLabel;
var isTextLabel = function (label) { return label.type === 'text'; };
exports.isTextLabel = isTextLabel;
// Helper utilities for decorating labels
var decorateLabel = function (label, props) {
    return __assign(__assign({}, label), props);
};
exports.decorateLabel = decorateLabel;
